module.exports = __webpack_public_path__ + "static/media/avatar.c8cf1ac5.png";